import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import { MySettingsComponent } from "../user/components/my-settings/my-settings.component";
import { BattleListComponent } from "./components/battle/battle-list/battle-list-component";
import { BattleDetailsComponent } from "./components/battle/battle-details/battle-details-component";

const routes: Routes = [
    {
        path: 'battles',
        component: BattleListComponent
    },
    {
        path: 'battles/:battleId',
        component: BattleDetailsComponent
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class PresetRoutingModule {
}
